import { fromJS } from 'immutable';
import { createReducer } from 'utils/redux';
import * as actionTypes from './actionTypes';

const initialState = {
  initialized: false,
  submit: {
    fetching: false,
    data: null,
    error: null,
  },
  confirm: {
    fetching: false,
    data: null,
    error: null,
  },
};

const onInitialized = (state) => state.set('initialized', true);

const onSubmit = (state) =>
  state.setIn(['submit', 'fetching'], true).setIn(['submit', 'error'], null);

const onSubmitSuccess = (state, { payload }) =>
  state.setIn(['submit', 'data'], fromJS(payload)).setIn(['submit', 'fetching'], false);

const onSubmitError = (state, { payload }) => state.setIn(['submit', 'error'], fromJS(payload));

const onConfirm = (state) =>
  state.setIn(['confirm', 'fetching'], true).setIn(['confirm', 'error'], null);

const onConfirmSuccess = (state, { payload }) =>
  state.setIn(['confirm', 'data'], fromJS(payload)).setIn(['confirm', 'fetching'], false);

const onConfirmError = (state, { payload }) => state.setIn(['confirm', 'error'], fromJS(payload));

const onReset = () => fromJS(initialState);

export default createReducer(fromJS(initialState), {
  [actionTypes.INITIALIZE_SUCCESS]: onInitialized,

  [actionTypes.SUBMIT]: onSubmit,
  [actionTypes.SUBMIT_SUCCESS]: onSubmitSuccess,
  [actionTypes.SUBMIT_FAILURE]: onSubmitError,

  [actionTypes.CONFIRM]: onConfirm,
  [actionTypes.CONFIRM_SUCCESS]: onConfirmSuccess,
  [actionTypes.CONFIRM_FAILURE]: onConfirmError,

  [actionTypes.RESET]: onReset,
});
